import { useEffect, useRef } from 'react'
import { Partner } from 'src/types'
import sanitizeHtml from 'sanitize-html'

const CompanyWith = ({
    partner,
    fill
}: {
    partner: Partner
    fill?: string
}) => {
    const svgContent = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (partner.logoUrl) {
            fetch(partner.logoUrl)
                .then(response => response.text())
                .then(svg => {
                    if (svgContent.current) {
                        const sanitizedSvg = sanitizeHtml(svg, {
                            allowedTags: [
                                'svg',
                                'path',
                                'g',
                                'defs',
                                'clipPath',
                                'rect'
                            ],
                            allowedSchemes: ['data'],
                            disallowedTagsMode: 'escape',
                            allowedAttributes: {
                                svg: [
                                    'xmlns',
                                    'viewBox',
                                    'width',
                                    'height',
                                    'id'
                                ],
                                path: ['d', 'fill', 'stroke'],
                                g: ['fill', 'stroke', 'clip-path'],
                                defs: [],
                                rect: [
                                    'x',
                                    'y',
                                    'width',
                                    'height',
                                    'rx',
                                    'ry',
                                    'transform',
                                    'fill'
                                ],
                                clipPath: ['id']
                            },
                            parser: {
                                lowerCaseAttributeNames: true,
                                lowerCaseTags: false,
                                xmlMode: false
                            }
                        })

                        svgContent.current.innerHTML = sanitizedSvg

                        if (fill) {
                            const paths =
                                svgContent.current.querySelectorAll('path')

                            //@ts-ignore
                            paths.forEach(p => p.setAttribute('fill', fill))
                        }
                    }
                })
                .catch(error => {
                    console.error('Error fetching SVG:', error)
                })
        }
    }, [partner.logoUrl])

    if (partner.logoUrl) {
        return (
            <>
                <div
                    style={{
                        height: `${
                            svgContent.current?.querySelector('svg')?.height
                                .baseVal.value || 20
                        }px`
                    }}
                    ref={svgContent}
                ></div>
            </>
        )
    } else {
        return <span>{partner.name}</span>
    }
}

export default CompanyWith
